import React, { useEffect, useState } from "react";
import { yStars, clipStar, ratingText } from "./style.mod.scss";
import { StarFill } from "react-bootstrap-icons";
import locale from "locales";
import { getMergedReviewsForCluster } from "../../data/trusted-reviews";

const PDPReviews = ({ variants }) => {
  const [averageRating, setAverageRating] = useState(null);
  const [totalReviews, setTotalReviews] = useState(0);

  useEffect(() => {
    const fetchReviews = async () => {
      const reviews = await getMergedReviewsForCluster(variants);

      if (variants && Array.isArray(variants)) {
        const clusters = variants.map(variant => variant.cluster).filter(Boolean);

        const filteredReviews = reviews.filter(review =>
          review.cluster && clusters.includes(review.cluster)
        );

        if (filteredReviews.length > 0) {
          const totalScore = filteredReviews.reduce((sum, review) => sum + (review.rating || 0), 0);
          setTotalReviews(filteredReviews.length);
          const avgRating = filteredReviews.length > 0 ? totalScore / filteredReviews.length : 0;
          setAverageRating(avgRating);
        }
      } else {
        console.log("No variants found or variants is not an array.");
      }
    };

    fetchReviews();
  }, [variants]);

  const round = (avg) => (avg ? Math.round(avg) : 0);
  const prec = (avg) => (isNaN(avg) ? "0.0" : Number.parseFloat(avg).toPrecision(2));
  const scrollToReviews = () => document.getElementById("y-product-reviews")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });

  return (
    <a className={yStars} onClick={scrollToReviews}>
      {averageRating &&
        Array(round(averageRating)).fill().map((_, index) => (
          <div key={index} className={clipStar}>
            <StarFill />
          </div>
        ))}
      {averageRating !== null && (
        <span className={ratingText}>
          {prec(averageRating)} ({totalReviews} {locale.pages.reviews.reviews})
        </span>
      )}
    </a>
  );
};

export default PDPReviews;